import { IDataPaymentState } from '../../types/redux/dataPayment';
import { TReduxActions } from '../../types/redux/actions';
import { EDataPaymentActions } from '../../constants/actionTypes/dataPayment';
import { EDemandRequestStatus } from '../../constants/demandRequestStatus';

export const defaultState: IDataPaymentState = {
  demandRequest: {
    status: EDemandRequestStatus.RealtorForm,
    phoneRequired: false,
    dealTypeRequired: false,
    isFetching: false,
    isError: false,
  },
};

export const dataPaymentReducer = (state = defaultState, action: TReduxActions): IDataPaymentState => {
  switch (action.type) {
    case EDataPaymentActions.SET_DEMAND_REQUEST_STATUS:
      return {
        ...state,
        demandRequest: {
          ...state.demandRequest,
          ...action.payload,
        },
      };
    case EDataPaymentActions.SET_PHONE:
      return {
        ...state,
        demandRequest: {
          ...state.demandRequest,
          phone: action.payload,
        },
      };
    case EDataPaymentActions.SET_DEAL_TYPE:
      return {
        ...state,
        demandRequest: {
          ...state.demandRequest,
          dealType: action.payload,
        },
      };
    case EDataPaymentActions.SEND_DEMAND_REQUEST:
      return {
        ...state,
        demandRequest: {
          ...state.demandRequest,
          isFetching: true,
          isError: false,
        },
      };
    case EDataPaymentActions.SEND_DEMAND_REQUEST_SUCCESS:
      return {
        ...state,
        demandRequest: {
          ...state.demandRequest,
          status: EDemandRequestStatus.RequestSent,
          isFetching: false,
        },
      };
    case EDataPaymentActions.SEND_DEMAND_REQUEST_ERROR:
      return {
        ...state,
        demandRequest: {
          ...state.demandRequest,
          isFetching: false,
          isError: true,
        },
      };
    default:
      return state;
  }
};
